import Api from "./api";

class UnloadingService {
    api = new Api();

    superGroups() {
        return this.api.post('/admin/unloading/super-groups');
    }

    groups() {
        return this.api.post('/admin/unloading/groups');
    }

    categories() {
        return this.api.post('/admin/unloading/categories');
    }

    categoriesWithItems() {
        return this.api.post('/admin/unloading/categories-with-items');
    }

    items() {
        return this.api.post('/admin/unloading/items');
    }

    sellers() {
        return this.api.post('/admin/unloading/sellers');
    }

    buyers() {
        return this.api.post('/admin/unloading/buyers');
    }
}

export default new UnloadingService();